module.exports = __webpack_public_path__ + "img/concreto_aparente.53aedb39.png";